import React, { useEffect, useState, useRef } from "react";
import { CardItem } from "./CardItem.jsx";
import { DrawerBiomarker } from "./BiomarkerDrawer.jsx";
import { get, post } from '../../../services/ApiService.js';
import Slider from "react-slick";
import { categoriesData } from "../../../data/BloodTestCategories.js";
import PageLoader from "../../../components/loader/PageLoader.jsx";

const TabAzTest = ({paramCategory}) => {

  const [biomarkerData, setBiomarkers] = useState([]);
  const [isNotFound, setNotFound] = useState(false);
  const [data, setData] = useState([]);
  const [isLoad, setIsLoad] = useState(true);
  const [ activeCategory, setActiveCategory ] = useState("0");
  const sliderRef = useRef(null); 
  const tabContentRef = useRef(null);
  

  var tabsSlider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 0,
    centerMode: false,
    autoplay: false,
    arrows: true,
    swipeToSlide: true,
    swipe: true,
    draggable: true,
    touchMove: true,        // Enable touch movement
    touchThreshold: 5,      // Reduced threshold to make it more sensitive
    useCSS: true,
    useTransform: true,
    waitForAnimate: false,  // Don't wait for animation to finish before responding to swipe
    pauseOnHover: true,     // Pause autoplay on hover
    accessibility: true,    // Enable keyboard navigation
    nextArrow: (
      <div>
        <img src="/assets/icons/next.png" width={25} alt="next" />
      </div>
    ),
    prevArrow: (
      <div>
        <img src="/assets/icons/prev.png" width={25} alt="prev" />
      </div>
    ),
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };


  useEffect(() => {
    const loadData = async () => {
      setIsLoad(true);
      try {
        await fetchData();
        await fetchBiomarkers();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoad(false);
      }
    };


    loadData();
    
  }, []);



  const fetchBiomarkers = async () => {
    try {
      const res = await get("api/blood-tests/biomarkers");
      if (res.success) {
        setBiomarkers(res.biomarkers);
      } else {
        setBiomarkers([]);
      }
    } catch (error) {
      setBiomarkers([]);
    }
  };

  const fetchData = async () => {
    try {
      setNotFound(false);
      const res = await get("api/blood-tests/all");
      if (res.success) {
        setData(res.data); 
      } else {
        setData([]); 
        setNotFound(true);
      }
    } catch (error) {
      setData([]);
      setNotFound(true);
    }
  };


  
  useEffect(() => {
    if (paramCategory) {
      const foundCategory = categoriesData.find((cat) => cat.slug === paramCategory);
      if (foundCategory) {
        setActiveCategory(foundCategory._id);
      }
    }else{
      setActiveCategory("0")
    }
  }, [paramCategory]);

  useEffect(() => {
    if (sliderRef.current) {
      const activeIndex = categoriesData.findIndex((cate) => cate._id === activeCategory);
      if (activeIndex !== -1) {
        sliderRef.current.slickGoTo(activeIndex); // Scroll to active category
      }
    }
  }, [activeCategory]);

    useEffect(() => {
      if (activeCategory && activeCategory !== "0") {
        if (tabContentRef.current) {
          tabContentRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, [activeCategory]);

  return (
    <>
    {isLoad && <PageLoader />}
    <div className="pt-lg-17 pt-10" ref={tabContentRef}>
      <div style={{ display: "none" }}>
        <button aria-hidden="true"></button>
        <input type="text" aria-hidden="true" />
      </div>
      <ul
        className="nav-pills mb-3 w-100 pill-cust hoverarrow p-0"
        id="pills-tab"
        role="tablist"
      >
        <div >
          <Slider ref={sliderRef} {...tabsSlider}>
            {
              categoriesData?.map((cate,index)=>
              <li className="nav-item flex-grow-1 slickli h-100" role="presentation" key={index}>
                <button
                  className={`nav-link w-100 d-flex flex-column align-items-center ${activeCategory === cate._id ? 'active': ''}`}
                  type="button"
                  onClick={() =>  setActiveCategory(cate._id)}
                >
                  <div>
                    <img
                      src={"/assets/icons/"+cate?.imgdef}
                      className="icon-b"
                      width={30}
                      alt=""
                    />
                    <img
                      src={"/assets/icons/"+cate?.imgactive}
                      className="icon-w"
                      width={30}
                      alt=""
                    />
                  </div>
                  <span className="metropill pt-5 pb-3">{cate?.heading}</span>
                </button>
              </li>
              )
            }
          </Slider>
        </div>
      </ul>
      <div className="tab-content">
        <div>
          <CardItem 
            bloodTests={data}
            biomarkerData={biomarkerData}
            isNotFound={isNotFound} 
            isLoad={isLoad}
            categories={categoriesData}
            activeCategory={activeCategory}
            setActiveCategory={setActiveCategory}
          />
        </div>
      </div>
      
    </div>
    </>
  );
};

export { TabAzTest };
